import { z } from 'zod';

export const backgroundCheckStatusSchema = z.enum([
  'checkr_passed',
  'ebr_fingerprint_passed',
  'ebr_fingerprint_quality_reject',
  'california_fingerprint_passed',
  'florida_fingerprint_passed',
  'florida_foundations_course_completed',
  'uva_cleared',
  'louisiana_can',
]);

export const techCheckTypeSchema = z.enum(['zoomTechCheck', 'googleMeetTechCheck']);
